import {Injectable} from "@angular/core";
import {AngularFire} from "angularfire2";
import {UserService} from "./user";
import {StatsService} from "./stats";
import {camelCase, each} from "*";
import {PostService} from "./post";

@Injectable()
export class CommentService {

  constructor(
    public af: AngularFire,
    public userService: UserService,
    public statsService: StatsService,
  ) {}

  updateBlockedStatus(comment: any, post: any, blocked: boolean) {
    comment.blocked = blocked
      ? PostService.postBlockStateBlocked
      : PostService.postBlockStateNotBlocked;

    return this.updateCommentMeta(comment, post)
      .then(() => {
        return Promise.all([
          this.statsService.trackTotalNumberOfBlockedComments(comment),
          this.statsService.trackRankedListOfBlockedComments(comment),
        ]);
      })
      .then(() => comment);
  }

  updateModeratedStatus(comment: any, post: any, moderated: boolean) {
    comment.moderated = moderated
      ? PostService.postModerateStateModerated
      : PostService.postModerateStateNotModerated;

    return this.updateCommentMeta(comment, post);
  }

  updateCommentMeta(comment: any, post: any, user: any = null): Promise<any> {
    return this.updateCommentByRef(`comments/${post.id}/${comment.chatId}/${comment.$key}`, comment);
  }

  updateCommentByRef(ref: string, comment: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.af.database.object(ref).take(1).subscribe(data => {
        if (!data.$exists()) {
          return resolve(comment);
        }

        return this.af.database
          .object(ref)
          .update(comment)
          .then((comment: any) => {
            return resolve(comment);
          })
          .catch(error => {
            return reject(error);
          });
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/comment.ts